<template>
	<div class="withdraw-setting-container">
		<!-- 顶部标签页：普通提现设置 / 大V提现规则 -->
		<el-tabs v-model="activeTab" @tab-click="changeSelectValue" type="card" class="withdraw-tabs">
			<el-tab-pane label="普通提现设置" name="normal">
				<div class="table-box">
					<!-- 顶部操作栏：新增按钮 -->
					<div class="operate-bar">
						<el-button type="primary" icon="el-icon-plus" @click="handleAdd('normal')">
							新增
						</el-button>
					</div>
					
					<!-- 提现配置表格 -->
					<el-table
							:data="normalList"
							border
							stripe
							header-cell-class-name="table-header"
							class="withdraw-table"
							v-loading="loading"
					>
						<el-table-column label="序号" type="index" align="center" width="70" />
						<el-table-column label="编号" prop="number" align="center" min-width="120" />
						<el-table-column label="提现类型名称" prop="typeName" align="center" min-width="160" />
						<el-table-column label="固定值" prop="fixedValue" align="center" min-width="120">
							<template slot-scope="scope">
								<span>{{ scope.row.fixedValue }} 元</span>
							</template>
						</el-table-column>
						<el-table-column label="是否启用" prop="isEnable" align="center" min-width="120">
							<template slot-scope="scope">
								<el-tag :type="scope.row.isEnable ? 'success' : 'danger'">
									{{ scope.row.isEnable ? '启用' : '禁用' }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="280">
							<template slot-scope="scope">
								<el-button
										type="primary"
										size="mini"
										icon="el-icon-edit"
										@click="handleEdit(scope.row, 'normal')"
								>
									编辑
								</el-button>
<!--								<el-button-->
<!--										type="danger"-->
<!--										size="mini"-->
<!--										icon="el-icon-delete"-->
<!--										@click="handleDelete(scope.row.number, 'normal')"-->
<!--								>-->
<!--									删除-->
<!--								</el-button>-->
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
			
			<el-tab-pane label="大V提现规则" name="bigV">
				<div class="table-box">
					<!-- 顶部操作栏：新增按钮 -->
					<div class="operate-bar">
						<el-button type="primary" icon="el-icon-plus" @click="handleAdd('bigV')">
							新增
						</el-button>
					</div>
					
					<el-table
							:data="bigVList"
							border
							stripe
							header-cell-class-name="table-header"
							class="withdraw-table"
							v-loading="loading"
					>
						<el-table-column label="序号" type="index" align="center" width="70" />
						<el-table-column label="编号" prop="number" align="center" min-width="120" />
						<el-table-column label="提现类型名称" prop="typeName" align="center" min-width="160" />
						<el-table-column label="固定值" prop="fixedValue" align="center" min-width="120">
							<template slot-scope="scope">
								<span>{{ scope.row.fixedValue }} 元</span>
							</template>
						</el-table-column>
						<el-table-column label="是否启用" prop="isEnable" align="center" min-width="120">
							<template slot-scope="scope">
								<el-tag :type="scope.row.isEnable ? 'success' : 'danger'">
									{{ scope.row.isEnable ? '启用' : '禁用' }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="280">
							<template slot-scope="scope">
								<el-button
										type="primary"
										size="mini"
										icon="el-icon-edit"
										@click="handleEdit(scope.row, 'bigV')"
								>
									编辑
								</el-button>
<!--								<el-button-->
<!--										type="danger"-->
<!--										size="mini"-->
<!--										icon="el-icon-delete"-->
<!--										@click="handleDelete(scope.row.number, 'bigV')"-->
<!--								>-->
<!--									删除-->
<!--								</el-button>-->
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		
		<!-- 新增/编辑 弹窗 -->
		<el-dialog
				:title="dialogTitle"
				:visible.sync="dialogVisible"
				width="40%"
				append-to-body
				:close-on-click-modal="false"
		>
			<el-form
					ref="formRef"
					:model="form"
					label-width="150px"
					class="withdraw-form"
			>
				<!-- 编号：新增时禁用，编辑时展示 -->
				<el-form-item label="编号" prop="number" :rules="[
            { required: true, message: '请输入编号', trigger: 'blur' }
          ]">
					<el-input v-model="form.number" placeholder="请输入编号"  />
				</el-form-item>
				
				<!-- 提现类型名称：必填 -->
				<el-form-item
						label="提现类型名称"
						prop="typeName"
						:rules="[
            { required: true, message: '请输入提现类型名称', trigger: 'blur' }
          ]"
				>
					<el-input v-model="form.typeName" placeholder="请输入" />
				</el-form-item>
				
				<!-- 固定值：金额校验 -->
				<el-form-item
						label="固定值（元）"
						prop="fixedValue"
						:rules="[
            { required: true, message: '请输入固定值', trigger: 'blur' },
            { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确金额（最多2位小数）', trigger: 'blur' }
          ]"
				>
					<el-input v-model="form.fixedValue" placeholder="请输入" suffix="元" />
				</el-form-item>
				
				<!-- 是否启用：开关 -->
				<el-form-item label="是否启用" prop="isEnable">
					<el-switch v-model="form.isEnable" active-text="启用" inactive-text="禁用" />
				</el-form-item>
				
				<!-- 提现类型：隐藏字段，自动赋值 -->
				<el-form-item label="提现类型" prop="commissionType" hidden>
					<el-input v-model="form.commissionType" />
				</el-form-item>
			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm">重置</el-button>
				<el-button type="primary" @click="submitForm">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
// 引入所有接口方法（和获取列表保持一致的调用方式）
import {
	getWithdrawalConfigList,
	addWithdrawalConfig,
	editWithdrawalConfig,
	deleteWithdrawalConfig, updateWithdrawalConfig
} from "../../api/api";
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
export default {
	name: "WithdrawSetting",
	data() {
		return {
			// 标签页
			activeTab: "normal",
			// 加载状态
			loading: false,
			// 普通设置列表
			normalList: [],
			// 大V设置列表
			bigVList: [],
			// 弹窗
			dialogVisible: false,
			dialogTitle: "新增提现设置",
			formType: "normal", // normal / bigV
			formRef: "formRef",
			form: {
				id:undefined,
				number: "",       // 编号（系统生成）
				typeName: "",     // 提现类型名称
				commissionType: "",// 提现类型：1-普通，2-大V
				fixedValue: "",   // 固定值
				isEnable: true    // 是否启用（默认启用）
			}
		};
	},
		mounted() {
		// 添加全局回车搜索功能
		useEnterSearch(() => {
			this.getTableList(this.formType);
		});
	},
	beforeDestroy() {
		// 移除全局回车监听
		removeEnterSearch();
	},
	created() {
		// 初始化加载数据
		this.getTableList(this.activeTab);
	},
	methods: {
		// 切换标签页重新加载数据
		changeSelectValue(value) {
			this.getTableList(value);
			this.formType = value;
		},
		// 获取列表数据（对接后台接口）
		async getTableList(type) {
			try {
				this.loading = true;
				// 根据类型请求不同接口（commissionType：1-普通，2-大V）
				const params = {
					commissionType: type === 'normal' ? 1 : 2
				};
				const res = await getWithdrawalConfigList(params);
				if (res.data.success) {
					// 赋值对应列表
					if (type === 'normal') {
						this.normalList = res.data.response;
					} else {
						this.bigVList = res.data.response;
					}
				}
			} catch (error) {
				console.error('获取提现配置列表失败：', error);
				this.$message.error('网络异常，获取数据失败');
			} finally {
				this.loading = false;
			}
		},
		// 新增
		handleAdd(type) {
			this.formType = type;
			this.dialogTitle = "新增提现设置";
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.$refs.formRef.resetFields();
				// 重置表单 + 自动赋值提现类型
				this.form = {
					number: "",
					typeName: "",
					commissionType: type === 'normal' ? 1 : 2,
					fixedValue: "",
					isEnable: true
				};
			});
		},
		// 编辑
		handleEdit(row, type) {
			this.formType = type;
			this.dialogTitle = "编辑提现设置";
			this.dialogVisible = true;
			this.$nextTick(() => {
				// 赋值编辑数据（深拷贝避免原数据被修改）
				this.form = { ...row };
				// 确保提现类型与标签页一致
				this.form.commissionType = type === 'normal' ? 1 : 2;
			});
		},
		// 删除（调用api删除方法）
		async handleDelete(number, type) {
			try {
				await this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				});
				
				// 调用api删除方法（和获取列表一样的调用方式）
				const res = await deleteWithdrawalConfig({
					number,
					commissionType: type === 'normal' ? 1 : 2
				});
				
				if (res.data.success) {
					this.$message.success("删除成功");
					// 重新加载列表
					await this.getTableList(type);
				} else {
					this.$message.error(res.data.msg || '删除失败');
				}
			} catch (error) {
				if (error !== 'cancel') { // 排除取消确认的情况
					console.error('删除提现配置失败：', error);
					this.$message.error('网络异常，删除失败');
				} else {
					this.$message.info("已取消删除");
				}
			}
		},
		// 表单重置
		resetForm() {
			this.$refs.formRef.resetFields();
			// 重置后恢复默认值
			this.form.isEnable = true;
			this.form.commissionType = this.formType === 'normal' ? 1 : 2;
		},
		// 提交保存（调用api新增/编辑方法）
		async submitForm() {
			try {
				await this.$refs.formRef.validate(); // 表单验证
				
				// 区分新增/编辑
				const isEdit = !!this.form.id;
				let res;
				if (isEdit) {
					// 编辑：调用api编辑方法
					res = await updateWithdrawalConfig(this.form);
				} else {
					// 新增：调用api新增方法（和获取列表一致的调用方式）
					res = await addWithdrawalConfig(this.form);
				}
				
				if (res.data.success) {
					this.$message.success(isEdit ? "编辑成功" : "新增成功");
					this.dialogVisible = false;
					// 重新加载列表
					await this.getTableList(this.formType);
				} else {
					this.$message.error(res.data.msg || (isEdit ? '编辑失败' : '新增失败'));
				}
			} catch (error) {
				console.error('保存提现配置失败：', error);
				this.$message.error('网络异常，保存失败');
			}
		}
	}
};
</script>

<style scoped>
.withdraw-setting-container {
	width: 95%;
	margin: 20px auto;
	background: #fff;
	padding: 20px;
	box-sizing: border-box;
}
.withdraw-tabs {
	margin-bottom: 15px;
}
.operate-bar {
	margin-bottom: 15px;
	text-align: left;
}
.withdraw-table {
	width: 100%;
	font-size: 13px;
}
.table-header {
	background: #f5f7fa !important;
	font-weight: 500;
}
.withdraw-form {
	padding: 10px 0;
}
.dialog-footer {
	text-align: right;
}
</style>